/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import smsIcon from 'my-phorest/assets/images/sms.svg';
import whatsappIcon from 'my-phorest/assets/images/whatsapp.svg';
import { service } from '@ember/service';

export default class ClientHeaderComponent extends Component {
  @service twoWayChat;
  smsIconSrc = smsIcon;
  whatsappIconSrc = whatsappIcon;
}
